// The KF CRM hosts — the JS twin of the `KfCrm` module in
// app/models/kf_crm.rb. Change both together.
//
// CRM_APP_URL is the CRM app a coach logs into. CRM_LINK_URL serves HighLevel
// form, survey, and calendar embeds. These replace app.gohighroad.com and
// api.gohighroad.com, which died when gohighroad.com lapsed on 2026-11-04.
export const CRM_APP_URL = "https://crm.kingdomfactor.us"
export const CRM_LINK_URL = "https://link.kingdomfactor.us"

// HighLevel's resizer script. Every page embedding a HighLevel form, survey,
// or calendar loads it from the link host.
export const CRM_EMBED_SCRIPT_URL = `${CRM_LINK_URL}/js/form_embed.js`
